/**
 * @description consistent masking logic for account, routing, and card numbers.
 *
 * @param {string} accountNumber
 * @returns {string}
 */
const maskPaymentValue = (accountNumber) => {
  accountNumber = accountNumber ? accountNumber.toString().trim() : '';

  if (accountNumber.length <= 4) {
    return `XXXXXX${accountNumber}`;
  }

  const maskedPart = accountNumber.slice(0, -4).replaceAll(/./g, 'X');
  const visiblePart = accountNumber.slice(-4);
  let maskedNumber = maskedPart + visiblePart;

  if (maskedNumber.length > 16) {
    maskedNumber = maskedNumber.slice(-16);
  }

  return maskedNumber;
};

module.exports = {
  maskPaymentValue,
};
